import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidePage from "../pages/guide/page";
import SerialPage from "../pages/serial/page";
import HotPage from "../pages/hot/page";
import ArticlePage from "../pages/article/page";
import AboutPage from "../pages/about/page";
import FaqPage from "../pages/faq/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/guide", element: <GuidePage /> },
  { path: "/serial", element: <SerialPage /> },
  { path: "/hot", element: <HotPage /> },
  { path: "/article/:id", element: <ArticlePage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/faq", element: <FaqPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;